import {
  ROLE_USER,
  ROLE_APPLICATION_DEV_ADMIN_PORTAL_TECH,
  ROLE_MERCHANT_PORTAL_ADMIN_TECH,
  ROLE_MERCHANT_PORTAL_ADMIN_FINANCE,
  ROLE_PSP_PORTAL_ADMIN_TECH,
  ROLE_PSP_PORTAL_ADMIN_FINANCE,
  ROLE_PSP_PORTAL,
  ROLE_PSP_MERCHANT_PORTAL,
  ROLE_VOLT_PORTAL_ADMIN,
  ROLE_VOLT_PORTAL_SUPPORT,
  ROLE_MERCHANT_PORTAL,
  ROLE_VOLT_PORTAL_STANDARD,
} from "../../config/roles";

const users = {
  "Merchant users": "Merchant users",
  pageDescription: `Users who can access the Volt merchant portal from your organisation.
Admin users can add other users, configure applications and make changes to your merchant account.
Standard users can view your transactions and invoices.`,
  "Add a new portal user": "Add a new portal user",
  "New portal user": "New portal user",
  Name: "Name",
  "Email address": "Email address",
  Password: "Password",
  "Password confirmation": "Password confirmation",
  "Portal access level": "Portal access level",
  "Account status": "Account status",
  userEnabled: "<0>Enabled</0> - user can access the merchant portal",
  userDisabled: "<0>Disabled</0> - user cannot access the merchant portal",
  "Last successful login": "Last successful login",
  "Create new user": "Create new user",
  "Delete user": "Delete user",
  Cancel: "Cancel",
  "Save user": "Save user",
  deleteUserConfirmationTitle: "Delete user",
  deleteUserConfirmationMessage:
    "User will be deleted immediately and permanently. Do you want to delete the user?",
  Delete: "Delete",
  roles: {
    [ROLE_USER]: "User",
    [ROLE_APPLICATION_DEV_ADMIN_PORTAL_TECH]:
      "Application developer admin tech",
    [ROLE_MERCHANT_PORTAL]: "Standard user",
    [ROLE_MERCHANT_PORTAL_ADMIN_TECH]: "Admin tech",
    [ROLE_MERCHANT_PORTAL_ADMIN_FINANCE]: "Admin finance",
    [ROLE_PSP_PORTAL_ADMIN_TECH]: "PSP Admin tech",
    [ROLE_PSP_PORTAL_ADMIN_FINANCE]: "PSP Admin finance",
    [ROLE_PSP_PORTAL]: "PSP standard user",
    [ROLE_PSP_MERCHANT_PORTAL]: "PSP merchant",
    [ROLE_VOLT_PORTAL_ADMIN]: "Volt admin",
    [ROLE_VOLT_PORTAL_SUPPORT]: "Volt support",
    [ROLE_VOLT_PORTAL_STANDARD]: "Volt standard",
  },
};

export default users;
